import React, {useState, useEffect} from 'react';
import { connect } from 'react-redux';
import {  useNavigate } from 'react-router-dom';
import Head from '../../components/head/Head'
import Foot from '../../components/foot/Foot'
import {  Input,message,Modal,Progress  } from 'antd';
import { init } from '../../utils/ethers'
import copy from 'copy-to-clipboard'
import {shareLink} from '../../utils/const'
import NumberFormat from 'react-number-format'
import contractAddress from "../../utils/contractAddress.json"
import Moment from 'react-moment'
import CountUp from "react-countup";
import { useTranslation } from 'react-i18next'
import {getTuanInfo, register,login} from "../../api";
import { CSSTransition } from 'react-transition-group';
import {
    WarningOutlined,CloseOutlined
  } from '@ant-design/icons';
  import './index.less';
const mapStateToProps=(state)=>{
    return{
        isLogin:state.isLogin,
        address:state.address,
        pAddress:state.pAddress,
        chain:state.chain,
        flash:state.flash,
    }
}

const Index = (props) => {
    const { t } = useTranslation()
    const [num,setNum] = useState(0)
    const [puser,setPuser] = useState("")
    const [allYeIdo,setAllYeIdo] = useState("")
    const [zhiBonus1, setZhiBonus1] = useState("")
    const [zhiBonus2, setZhiBonus2] = useState("")
    const [allYe, setAllYe] = useState("")
    const [big,setBig] = useState("")
    const [small,setSmall] = useState("")
    const [smallIdo,setSmallIdo] = useState("")
    const [shareLink,setshareLink] = useState("")
    const [fcode,setFcode] = useState("")
    const [zhiNum,setZhiNum] = useState("")
    const [tuanNum,setTuanNum] = useState("")
    const [childs,setChilds] = useState([])
    const [levelPledge,setLevelPledge] =useState(0)

    const navigate = useNavigate()//hook事件路由跳转
    
    
    const _copy1 =()=>{
        if(fcode.length>0){

                copy(fcode);message.success(t('share.已复制')+":"+fcode)

        }
        
    }

    const _copy =()=>{
        if(shareLink.length>0){

                copy(shareLink);message.success(t('share.已复制')+":"+shareLink)

        }
        
    }
 

    const _getTuanInfo = () =>{
      
        if(props.address.length>0 && props.isLogin){
            getTuanInfo().then(res=>{
                if(res.code == 0){
                   
                    setBig(res.data.big)
                    setSmall(res.data.small)
                    setAllYe(res.data.allYe)
                    setAllYeIdo(res.data.allYe_ido)
                   setSmallIdo(res.data.small_ido)
                    
                    setZhiBonus1(res.data.zhiBonus1)
                    setZhiBonus2(res.data.zhiBonus2)
                    setLevelPledge(res.data.Level_pledge)
                    setshareLink(res.data.shareLink)
                    setFcode(res.data.fcode)
                    setTuanNum(res.data.tuanNum)
                    setZhiNum(res.data.zhiNum)
                    if(res.data.zhi!==null){
                        setChilds(res.data.zhi)
                    }
                    
                }else{
                    message.error(res.msg)
                }
               console.log(res)
            })
        }
    }

    



   




    useEffect(() => {
        window.scrollTo(0, 0)
           
            _getTuanInfo()
    }, 
    // eslint-disable-next-line
    [props.isLogin,num]);

    return (
        <>
            <Head/>
            

            
            
            <div style={{"backgroundColor":"#18120A"}} className=' invitebg77 w-full lg:w-1/3 min-h-screen px-4 pt-20 text-white flex flex-col'>


                <div className=' w-full h-6 mx-auto mt-24  pt-1 flex flex-row justify-center items-center  '>
                    <img alt='rr' className=' mr-2' src={require('../../assets/bg/share/title.png')} style={{"width":"42px"}}></img>
                    <span className=' text-sm text-text-act'>{t('share.船员邀请')}</span>
                    <img alt='rr' className=' ml-2' src={require('../../assets/bg/share/title.png')} style={{"width":"42px"}}></img>
                </div>
                <div className="w-full mt-4 h-28 flex flex-row justify-center items-center shareBg1">
                    <div className='w-1/2 flex flex-col items-center justify-center'>
                            <span className='text-lg text-white'><CountUp start={0} end={zhiNum} duration="1" decimals={0} /></span>
                            <span className='text-base  text-gray-400'>{t('share.邀请数')}</span>
                    </div>
                    <div className='w-px  h-9' style={{"backgroundColor":"#261A0E"}}>
                            
                    </div>
                    <div className='w-1/2 flex flex-col items-center justify-center'>
                            <span className='text-lg text-white'><CountUp start={0} end={tuanNum} duration="1" decimals={0} /></span>
                            <span className='text-base  text-gray-400'>{t('share.团队数')}</span>
                    </div>
                    

                </div>

                <div className=' w-full h-6 mx-auto mt-9  pt-1 flex flex-row justify-center items-center  '>
                    <img alt='rr' className=' mr-2' src={require('../../assets/bg/share/title.png')} style={{"width":"42px"}}></img>
                    <span className=' text-sm text-text-act'>{t('share.邀请链接')}</span>
                    <img alt='rr' className=' ml-2' src={require('../../assets/bg/share/title.png')} style={{"width":"42px"}}></img>
                </div>

                <div className=' w-full flex flex-row mb-6 mt-3 px-5 py-2 h-14 text-base text-white shareBg3'>
                    <span className=' px-1 py-2 text-sm'>{shareLink}</span>
                </div>

                <div className='w-full flex flex-row justify-center items-center mt-2'>
                    {/* <button  onClick={_copy1}  className='w-28 h-10  mr-8  shareBg4 text-sm text-white font-extrabold '>{t('share.拷贝邀请码')}</button> */}
                    <button  onClick={_copy}  className='w-44 h-10    shareBg4 text-sm text-white font-extrabold '>{t('share.拷贝链接')}</button>
                </div>

                <div className=' w-full h-6 mx-auto mt-9  pt-1 flex flex-row justify-center items-center  '>
                    <img alt='rr' className=' mr-2' src={require('../../assets/bg/share/title.png')} style={{"width":"42px"}}></img>
                    <span className=' text-sm text-text-act'>{t('share.船票业绩')}</span>
                    <img alt='rr' className=' ml-2' src={require('../../assets/bg/share/title.png')} style={{"width":"42px"}}></img>
                </div>

                <div className="w-full mt-4 h-72 px-5 pt-7 flex flex-col justify-start items-center shareBg2">
                    <div className='w-full flex flex-row justify-between items-center'>
                        <span className=' text-sm text-gray-200'>{t('share.团队业绩')}</span>
                        <span className=' text-base text-white'><CountUp start={0} end={allYeIdo} duration="1" decimals={2} /></span>
                    </div>
                    <div className='w-full h-px my-3' style={{"backgroundColor":"#261A0E"}}></div>
                    <div className='w-full flex flex-row justify-between items-center'>
                        <span className=' text-sm text-gray-200'>{t('share.小区业绩')}</span>
                        <span className=' text-base text-white'><CountUp start={0} end={smallIdo} duration="1" decimals={2} /></span>
                    </div>
                    {/* <div className='w-full h-px my-3' style={{"backgroundColor":"#261A0E"}}></div>
                    <div className='w-full flex flex-row justify-between items-center'>
                        <span className=' text-sm text-gray-200'>{t('share.大区业绩')}</span>
                        <span className=' text-base text-white'><CountUp start={0} end={big} duration="1" decimals={2} /></span>
                    </div> */}
                    <div className='w-full h-px my-3' style={{"backgroundColor":"#261A0E"}}></div>
                    <div className='w-full flex flex-row justify-between items-center'>
                        <span className=' text-sm text-gray-200'>{t('share.推荐奖励1')}</span>
                        <span className=' text-base text-white'><CountUp start={0} end={zhiBonus1} duration="1" decimals={2} /></span>
                    </div>
                    <div className='w-full h-px my-3' style={{"backgroundColor":"#261A0E"}}></div>
                    <div className='w-full flex flex-row justify-between items-center'>
                        <span className=' text-sm text-gray-200'>{t('share.推荐奖励2')}</span>
                        <span className=' text-base text-white'><CountUp start={0} end={zhiBonus2} duration="1" decimals={2} /></span>
                    </div>
                    <div className='w-full h-px my-3' style={{"backgroundColor":"#261A0E"}}></div>
                </div>

                 <div className=' w-full h-6 mx-auto mt-9  pt-1 flex flex-row justify-center items-center  '>
                    <img alt='rr' className=' mr-2' src={require('../../assets/bg/share/title.png')} style={{"width":"42px"}}></img>
                    <span className=' text-sm text-text-act'>{t('share.矿工业绩')}</span>
                    <img alt='rr' className=' ml-2' src={require('../../assets/bg/share/title.png')} style={{"width":"42px"}}></img>
                </div>

                <div className="w-full mt-4 h-52 px-5 pt-7 flex flex-col justify-start items-center shareBg2">
                    <div className='w-full flex flex-row justify-between items-center'>
                        <span className=' text-sm text-gray-200'>{t('share.团队业绩')}</span>
                        <span className=' text-base text-white'><CountUp start={0} end={allYe} duration="1" decimals={2} /></span>
                    </div>
                    <div className='w-full h-px my-3' style={{"backgroundColor":"#261A0E"}}></div>
                    <div className='w-full flex flex-row justify-between items-center'>
                        <span className=' text-sm text-gray-200'>{t('share.小区业绩')}</span>
                        <span className=' text-base text-white'><CountUp start={0} end={small} duration="1" decimals={2} /></span>
                    </div>
                    <div className='w-full h-px my-3' style={{"backgroundColor":"#261A0E"}}></div>
                    <div className='w-full flex flex-row justify-between items-center'>
                        <span className=' text-sm text-gray-200'>{t('share.等级')}</span>
                        <span className=' text-base text-white'>
                            {
                                levelPledge==0?t('share.普通'):levelPledge==1?t('share.星际探索者'):levelPledge==2?t('share.星际先锋'):levelPledge==3?t('share.星际指挥官'):levelPledge==4?t('share.星际领主'):levelPledge==5?t('share.星际执政官'):levelPledge==6?t('share.星际守护者'):t('share.星际元首')
                            }
                        </span>
                    </div>
                    {/* <div className='w-full h-px my-3' style={{"backgroundColor":"#261A0E"}}></div>
                    <div className='w-full flex flex-row justify-between items-center'>
                        <span className=' text-sm text-gray-200'>{t('share.大区业绩')}</span>
                        <span className=' text-base text-white'><CountUp start={0} end={big} duration="1" decimals={2} /></span>
                    </div> */}
                    <div className='w-full h-px my-3' style={{"backgroundColor":"#261A0E"}}></div>
                   
                  
                    
                </div>

                

                <div className=' w-full h-6 mx-auto mt-12  pt-1 flex flex-row justify-center items-center  '>
                    <img alt='rr' className=' mr-2' src={require('../../assets/bg/share/title.png')} style={{"width":"42px"}}></img>
                    <span className=' text-sm text-text-act'>{t('share.邀请记录')}</span>
                    <img alt='rr' className=' ml-2' src={require('../../assets/bg/share/title.png')} style={{"width":"42px"}}></img>
                </div>

                <div className=' w-full flex-col mt-4'>
                    <div  className='w-full h-12 shareBgList1 flex flex-row  text-gray-300 pt-2'>
                        <div className=' w-4/12 flex flex-row justify-center items-center '>{t('share.地址')}</div>
                        <div className=' w-4/12 flex flex-row justify-center items-center'>{t('share.时间')}</div>
                        <div className=' w-4/12 flex flex-row justify-center items-center'>{t('share.船票')}(BNB)</div>
                    </div>
                    
                    <div  className=' w-full min-h-48 shareBgList2 flex flex-col  text-white '>
                        {
                            childs.length>0?
                            childs.map((item,index)=>{
                                return(
                                    <div key ={item.id}>
                                    <div  className=' w-full h-12  flex flex-row items-center  '>
                                        <div className=' w-4/12 flex flex-row justify-center items-center '>
                                            {/* <img alt='rr' className=' mr-1 ' src={require('../../assets/icon/bnblogo.png')} style={{"height":"20px"}}></img> */}
                                            <span className=' font10 text-white font-bold'>{item.address}</span>
                                        </div>
                                        <div className=' w-4/12 flex flex-row justify-center items-center'>
                                            
                                            <span className=' font10  text-gray-600 font-bold'>{item.add_time}</span>
                                        </div>
                                        <div className=' w-4/12 flex flex-row justify-center items-center'>
                                            {/* <img alt='rr' className=' mr-1 ' src={require('../../assets/icon/usdtlogo.png')} style={{"height":"16px"}}></img> */}
                                            <span className=' text-sm  text-text1 font-bold'>
                                            <NumberFormat
                                                thousandsGroupStyle="thousand"
                                                value={item.eth}
                                                prefix=""
                                                decimalSeparator="."
                                                displayType="text"
                                                type="text"
                                                thousandSeparator={true}
                                                allowNegative={false}
                                                fixedDecimalScale={true}
                                                decimalScale={2} />
                                            </span>
                                        </div>
                                    </div>
                                    <div className=' mx-4 h-px ' style={{"backgroundColor":"#2D1D0D"}}></div>
                                    </div>
                                    
                                )
                            }):(
                                
                                <div  className=' w-full h-28 py-3 mt-5 flex flex-row items-center justify-center text-gray-600 text-xs'>
                                        No data
                                </div>
                            )
                        }

                        
                         
                    </div>
                    <div  className=' w-full h-12 shareBgList3 flex flex-row  text-white '>
                        
                    </div>

                </div>




                
            </div>
            

                <div className=' w-full h-44 ' style={{"backgroundColor":"#18120A"}}></div>
           <Foot/>
        </>
    );
}

const mapDispatchToProps = (dispatch) =>{
    return{

        setIsLogin(value){
            const action ={type:"setIsLogin",value:value}
            dispatch(action)
        },

        setPAddress(value){
            const action ={type:"setPAddress",value:value}
            dispatch(action)
        }
    }
}
export default connect(mapStateToProps,mapDispatchToProps)(Index);
